$(document).ready(function () {
  const navSearch = $('.navbar-search');
  const mobileNavSearch = $('.mobile-navbar-search');

  if (navSearch.length > 0 && mobileNavSearch.length > 0) {
    // update nav search value
    const navbar = $('.navbar-collapse');
    const navbarMenu = navbar.find('.nav.navbar-left');

    // Show
    navSearch
      .find('.search-icon')
      .unbind('click')
      .bind('click', function () {
        $(this).addClass('hide');
        navSearch.find('.search-wrap').removeClass('hide');
        navSearch.find('.search-input').focus();
        if (window.innerWidth < 1600 && navbar.hasClass('navbar-flex')) {
          navbarMenu.addClass('hide');
        }
      });

    // Hide
    navSearch
      .find('.close-search-icon')
      .unbind('click')
      .bind('click', function () {
        navSearch.find('.search-wrap').addClass('hide');
        navSearch.find('.search-icon').removeClass('hide');
        navbarMenu.removeClass('hide');
      });

    // mobile nav search
    mobileNavSearch
      .find('.clear-search-icon')
      .unbind('click')
      .bind('click', function () {
        mobileNavSearch.find('.search-input').val('').focus();
      });
  }
});
